const blog = document.querySelector('.blog');

if (blog) {
  document.addEventListener('DOMContentLoaded', function () {
    // Sélectionner tous les boutons de catégories et les articles
    const categoryButtons = document.querySelectorAll('.blog__categories--btn');
    const blogPosts = document.querySelectorAll('.blog__post');

    categoryButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        // Récupérer la catégorie sélectionnée (la valeur "all" pour afficher tous)
        const selectedCategory = this.getAttribute('data-category');

        // Retirer la classe "active" de tous les boutons puis l'ajouter à celui cliqué
        categoryButtons.forEach((b) => b.classList.remove('active'));
        this.classList.add('active');

        // Pour chaque article, vérifier si son attribut data-categories contient la catégorie sélectionnée
        blogPosts.forEach((post) => {
          const postCategories = post.getAttribute('data-categories').split(',');
          // Afficher l'article s'il appartient à la catégorie sélectionnée ou si "all" est sélectionné
          if (selectedCategory === 'all' || postCategories.includes(selectedCategory)) {
            post.style.display = '';
          } else {
            post.style.display = 'none';
          }
        });
      });
    });
  });
}
